import type { AllRouteEndpoints } from "../routeTypes";
export const engagementContentBlocksIdCacheKeys: AllRouteEndpoints[] = [
  "/engagement/content_blocks",
  "/engagement/draganddrop_content_blocks",
  "/engagement/content_blocks/:id",
];
export const engagementContentBlocksId = "/engagement/content_blocks/:id";
